<template>
   <div>
    <Despacho />
   </div>
  </template>
  <script>
  import Vue from "vue";
  import axios from "axios";
  import vSelect from "vue-select";
import Despacho from "./Empacar/ScreenEmpacar.vue";
  export default {
    data() {
      return {
        Ventas: [],
        despachar:false,
        DetalleVenta: [],
        userVentas: [],
        popupActivoGuardar: false,
        popupActivoEditar: false,
        popupActivoDesactivar: false,
        popupActivoEliminar: false,
        tabVentas: {
          ven_codigo: "",
          bod_responsable: "",
          bod_nombre: "",
          bod_ubicacion: "",
          bod_estado: "",
          created_at: "",
        },
        ven_codigo: 0,
        valorBusqueda: "0",
        Bodega_inactivos: [],
        busquedaxcodigo: "",
        checkBox_mostrarinactivos: false,
        contadorpendientes: 0,
      };
    },
    components: {
      "v-select": vSelect,
      Despacho,
    },
    mounted() {
      this.verificarseleccion();
    },
    methods: {
      verificarseleccion() {
        this.Ventas = [];
        if (this.valorBusqueda == 0) {
          this.getmetodoconfirmacionpendientes();
        }
      },
      getmetodoconfirmacionpendientes() {
        // console.log(this.contadorpendientes, "cuantos");
        if (this.contadorpendientes === 0) {
          this.getVentasPendientes();
        }
        // Configurar un temporizador para restablecer contadorpendientes después de 1 segundo
        setTimeout(() => {
          this.contadorpendientes = 0;
        }, 1000);
      },
      getVentasPendientes() {
        let me = this;
        this.contadorpendientes = 1;
        this.busquedaxcodigo = '';
        me.$vs.loading()
        this.$http.get(this.$server_url + 'GetVentasPendientes')
          .then(res => {
            this.Ventas = res.data;
            me.$vs.loading.close()
            if (me.Ventas.length == 0) {
              me.$vs.notify({
                text: 'No hay ventas pendientes por despachar',
                color: 'danger',
                iconPack: 'feather',
                icon: 'icon-x'
              })
            }
          })
          .catch(err => {
            console.log(err)
            me.$vs.loading.close()
          })
      },
      getVentaDespachadasxParametro() {
        let me = this;
        if (me.busquedaxcodigo.length < 2) {
          me.$vs.notify({
            text: "Minimo 2 caracteres de busqueda",
            color: "warning",
            iconPack: "feather",
            icon: "icon-check",
          });
          return false;
        }
        me.$vs.loading();
        this.$http.get(this.$server_url +"GetVentasDespachadasxParametro?parte_documento="+me.busquedaxcodigo)
          .then(function (res) {
            me.Ventas = res.data;
            if (me.Ventas.length === 0) {
              me.$vs.notify({
                text: "No hay Ventas para esta búsqueda",
                color: "danger",
                iconPack: "feather",
                icon: "icon-x",
              });
              me.Ventas = [];
              me.getUserBodega();
              me.$vs.loading.close();
            } else {
              // me.filtroRegion();
              me.$vs.loading.close();
              if (res.data.message) {
                me.$vs.notify({
                  text: res.data.message,
                  color: "success",
                  iconPack: "feather",
                  icon: "icon-user",
                });
              }
            }
          })
          .catch(function (error) {
            if (error.response && error.response.status === 404) {
              me.$vs.notify({
                text: "No hay Ventas para esta búsqueda",
                color: "danger",
                iconPack: "feather",
                icon: "icon-x",
              });
              me.Ventas = [];
              me.$vs.loading.close();
            } else {
              console.log(error + " error");
              me.$vs.loading.close();
            }
          });
      },
      getDetalleVentaxParametro(codigodocumento) {
        let me = this;
        console.log(codigodocumento)
        me.$vs.loading();
        this.$http.get(this.$server_url +"GetDetalleVentaxNumeroDocumentoParametro?numero_documento="+codigodocumento)
          .then(function (res) {
            me.DetalleVenta = res.data;
            if (me.DetalleVenta.length === 0) {
              me.$vs.notify({
                text: "No hay Detalle Venta para esta búsqueda",
                color: "danger",
                iconPack: "feather",
                icon: "icon-x",
              });
              me.DetalleVenta = [];
              me.getUserBodega();
              me.$vs.loading.close();
            } else {
              // me.filtroRegion();
              me.$vs.loading.close();
              if (res.data.message) {
                me.$vs.notify({
                  text: res.data.message,
                  color: "success",
                  iconPack: "feather",
                  icon: "icon-user",
                });
              }
            }
          })
          .catch(function (error) {
            if (error.response && error.response.status === 404) {
              me.$vs.notify({
                text: "No hay Detalle Venta para esta búsqueda",
                color: "danger",
                iconPack: "feather",
                icon: "icon-x",
              });
              me.DetalleVenta = [];
              me.$vs.loading.close();
            } else {
              console.log(error + " error");
              me.$vs.loading.close();
            }
          });
      },
      getEditar(tr) {
        this.popupActivoEditar = true;
        this.tabVentas.ven_codigo = tr.ven_codigo;
        this.tabVentas.bod_nombre = tr.bod_nombre;
        this.tabVentas.bod_ubicacion = tr.bod_ubicacion;
        this.tabVentas.bod_responsable = tr.bod_responsable;
        this.getDetalleVentaxParametro(tr.ven_codigo);
      },
      editar() {
        let me = this;
        const usuariorespo = localStorage.getItem("usuario");
        const usuarioObjeto = JSON.parse(usuariorespo);
        const idusuarioresp = usuarioObjeto.idusuario;
        if (
          (this.tabVentas.bod_nombre === "" || this.tabVentas.bod_nombre === null) &&
          (this.tabVentas.bod_ubicacion === "" || this.tabVentas.bod_ubicacion === null) &&
          (this.tabVentas.bod_responsable === "" || this.tabVentas.bod_responsable === null)
        ) {
          me.$vs.notify({
            text: "Escriba los datos de la bodega antes de editar",
            color: "danger",
            iconPack: "feather",
            icon: "icon-alert-triangle",
          });
          return;
        }
        let datos = {
          ven_codigo: this.tabVentas.ven_codigo,
          bod_nombre: this.tabVentas.bod_nombre,
          bod_ubicacion: this.tabVentas.bod_ubicacion,
          bod_responsable: this.tabVentas.bod_responsable,
        };
        me.$vs.loading();
        this.$http
          .post(this.$server_url + "PostBodega_Registrar_modificar", datos)
          .then((res) => {
            me.$vs.loading.close();
            this.getBodega();
            me.$vs.notify({
              text: "Bodega editada con exito",
              color: "success",
              iconPack: "feather",
              icon: "icon-check",
            });
            this.popupActivoEditar = false;
            this.popupActivoDesactivar = false;
            this.popupActivoGuardar = false;
            this.popupActivoEliminar = false;
          })
          .catch((error) => {
            console.log(error);
            me.$vs.loading.close();
            me.$vs.notify({
              text: "Bodega no se pudo editar",
              color: "danger",
              iconPack: "feather",
              icon: "icon-x",
            });
          });
      },
      getCancelar() {
        this.popupActivoEditar = false;
        this.popupActivoGuardar = false;
        this.popupActivoEliminar = false;
        this.popupActivoDesactivar = false;
      },
      popup_desactivar_activar_bodega(tr) {
        this.popupActivoDesactivar = true;
        this.ven_codigo = tr.ven_codigo;
        this.tabVentas.bod_nombre = tr.bod_nombre;
        this.tabVentas.bod_estado = tr.bod_estado;
      },
      desactivar_activar_bodega() {
        let me = this;
        let valornuevo = this.tabVentas.bod_estado;
        console.log(valornuevo + "valornuevoeatdobodutp" + this.ven_codigo);
        if (valornuevo == 1) {
          valornuevo = 0;
          let datos = {
            ven_codigo: this.ven_codigo,
            bod_estado: valornuevo,
          };
          me.$vs.loading();
          this.$http
            .post(this.$server_url + "Desactivar_Bodega", datos)
            .then((res) => {
              me.$vs.loading.close();
              this.getBodega();
              me.$vs.notify({
                text: "Cambio de estado exitoso",
                color: "success",
                iconPack: "feather",
                icon: "icon-check",
              });
              this.popupActivoEditar = false;
              this.popupActivoDesactivar = false;
              this.popupActivoGuardar = false;
              this.popupActivoEliminar = false;
            })
            .catch((error) => {
              console.log(error);
              me.$vs.loading.close();
              me.$vs.notify({
                text: "No se pudo realizar el cambio de estado",
                color: "danger",
                iconPack: "feather",
                icon: "icon-x",
              });
            });
        } else if (valornuevo == 0) {
          valornuevo = 1;
          let datos = {
            ven_codigo: this.ven_codigo,
            bod_estado: valornuevo,
          };
          me.$vs.loading();
          this.$http
            .post(this.$server_url + "Desactivar_Bodega", datos)
            .then((res) => {
              me.$vs.loading.close();
              this.getVentasPendientes();
              me.$vs.notify({
                text: "Cambio de estado exitoso",
                color: "success",
                iconPack: "feather",
                icon: "icon-check",
              });
              this.popupActivoEditar = false;
              this.popupActivoDesactivar = false;
              this.popupActivoGuardar = false;
              this.popupActivoEliminar = false;
            })
            .catch((error) => {
              console.log(error);
              me.$vs.loading.close();
              me.$vs.notify({
                text: "No se pudo realizar el cambio de estado",
                color: "danger",
                iconPack: "feather",
                icon: "icon-x",
              });
            });
        }
      },
      getPreguntaEliminar(tr) {
        this.popupActivoEliminar = true;
        this.ven_codigo = tr.ven_codigo;
        this.tabVentas.bod_nombre = tr.bod_nombre;
      },
      getEliminar() {
        let me = this;
        let datos = {
          ven_codigo: this.ven_codigo,
        };
        me.$vs.loading();
        this.$http
          .post(this.$server_url + "Eliminar_Bodega", datos)
          .then((res) => {
            me.getBodega();
            me.$vs.loading.close();
            me.$vs.notify({
              text: "Bodega eliminada con exito",
              color: "success",
              iconPack: "feather",
              icon: "icon-check",
            });
            this.popupActivoEditar = false;
            this.popupActivoDesactivar = false;
            this.popupActivoGuardar = false;
            this.popupActivoEliminar = false;
          })
          .catch(function (error) {
            console.log(error);
            me.$vs.loading.close();
            me.$vs.notify({
              text: "Bodega no se pudo eliminar",
              color: "danger",
              iconPack: "feather",
              icon: "icon-x",
            });
          });
      },
    },
  };
  </script>